export default __webpack_public_path__ + "./audio/message_recieved.2d76cad49c835a962389b199fcb45056.mp3";